import {useWallet} from "use-wallet";
import useSushi from "../../../hooks/useSushi";
import {useCallback, useContext} from "react";
import {FarmContext} from "../../../contexts/farm_provider/farm_provider";
import BigNumber from "bignumber.js";


export const NotifyRewardAmount = () => {
    const {account} = useWallet();
    const {sC} = useContext(FarmContext);

    const notifyReward = useCallback(async (amount: any) => {
        const txHash = await sC.methods
            .notifyRewardAmount( new BigNumber(amount).times(new BigNumber(10).pow(18)).toString())
            .send({from: account})
            .on('transactionHash', (tx: any) => {
                console.log(tx);
                return tx.transactionHash
            });
        return txHash
    }, [account]);

    return {notifyReward}
};


export const UpdatePause = () => {
    const {account} = useWallet();
    const {sC} = useContext(FarmContext);

    const updatePause = useCallback(async () => {
        const txHash = await sC.methods
            .updatePause()
            .send({from: account})
            .on('transactionHash', (tx: any) => {
                console.log(tx);
                return tx.transactionHash
            });
        return txHash
    }, [account]);

    return {updatePause}
};
